var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "97ok87781a",
    x1: "-24.259%",
    x2: "75.716%",
    y1: "24.29%",
    y2: "124.265%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0xae5d50wb",
    x1: "43%",
    x2: "55%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ie4alcptxc",
    x1: "-7541%",
    x2: "1285%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "62xxyzs3jd",
    x1: "19.703%",
    x2: "107.228%",
    y1: "10.441%",
    y2: "78.542%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-463 -96) translate(463 96)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 40,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H96V96H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4A4D4E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M83.015 48L77.25 48M48 18.5L48 12.885M48 83.015L48 77.25M12.985 48L18.75 48"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#4A4D4E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.545 4.15L47.835.005M56.885 15.145L60.84 12.835M56.85 45.545L60.995 47.835M45.855 56.885L48.165 60.84M15.455 56.85L13.165 60.995M4.115 45.855L.16 48.165M4.15 15.455L.005 13.165M15.145 4.115L12.835.16",
    transform: "translate(17.5 17.5)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#E60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M48 48L70.25 48M48 48L48 27.5"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "nonzero",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.25 2H2C.895 2 0 1.105 0 0v1c0 1.105.895 2 2 2h22.25c.617-.002 1.2-.29 1.577-.778.377-.489.507-1.124.353-1.722-.227.88-1.02 1.497-1.93 1.5z",
    transform: "translate(46 47)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "nonzero",
    d: "M48 13c19.33 0 35 15.67 35 35S67.33 83 48 83 13 67.33 13 48c.022-19.32 15.68-34.978 35-35zm0-5C25.909 8 8 25.909 8 48s17.909 40 40 40 40-17.909 40-40c0-10.609-4.214-20.783-11.716-28.284C68.783 12.214 58.61 8 48 8z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "nonzero",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0C20.68.022 5.022 15.68 5 35v.5C5 16.17 20.67.5 40 .5s35 15.67 35 35V35C74.978 15.68 59.32.022 40 0zM40 75C18.102 75.002.274 57.396 0 35.5v.5c0 22.091 17.909 40 40 40s40-17.909 40-40v-.5C79.726 57.396 61.898 75.002 40 75z",
    transform: "translate(8 12)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#97ok87781a)",
    fillRule: "nonzero",
    d: "M69.325 46l-19.9-19.905c.369.375.575.88.575 1.405V46h19.325z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#0xae5d50wb)",
    fillRule: "nonzero",
    d: "M49.405 26.075L49.355 26.025 49.355 26.025z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 13c-15.6-.015-29.327 10.297-33.657 25.284-4.331 14.986 1.78 31.03 14.983 39.339 13.203 8.308 30.311 6.876 41.949-3.513L46.53 49.365c.38.407.913.637 1.47.635h22.25c.803-.001 1.528-.483 1.84-1.224.312-.74.15-1.595-.41-2.171l10.19 10.19c2.722-10.484.436-21.638-6.19-30.207C69.052 18.02 58.831 13.002 48 13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ie4alcptxc)",
    fillRule: "nonzero",
    d: "M84.5 64.375l-.03.07.03-.07z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#62xxyzs3jd)",
    fillRule: "nonzero",
    d: "M71.68 46.605c.56.576.722 1.43.41 2.171-.312.74-1.037 1.223-1.84 1.224H48c-.552-.002-1.078-.232-1.455-.635L71.29 74.11c5.166-4.599 8.856-10.623 10.605-17.315L71.69 46.605h-.01z",
    opacity: 0.2
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.a64b8cae.svg";
export { ForwardRef as ReactComponent };